const arabicMonths = [
  "يناير",
  "فبراير",
  "مارس",
  "أبريل",
  "مايو",
  "يونيو",
  "يوليو",
  "أغسطس",
  "سبتمبر",
  "أكتوبر",
  "نوفمبر",
  "ديسمبر",
];

const englishMonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const generatePeriods = (yearsCount = 3) => {
  const periods = [];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  for (let year = currentYear - yearsCount; year <= currentYear; year += 1) {
    for (let month = 1; month <= 12; month += 1) {
      const monthStr = String(month).padStart(2, "0");
      periods.push({
        value: `${year}-${monthStr}`,
        labelAr: `${arabicMonths[month - 1]} ${year}`,
        labelEn: `${englishMonths[month - 1]} ${year}`,
      });
    }
  }

  return periods.sort((a, b) => b.value.localeCompare(a.value));
};

const generatedPeriods = generatePeriods();

export const PERIODS = {
  ar: generatedPeriods.map((period) => ({
    value: period.value,
    label: period.labelAr,
  })),
  en: generatedPeriods.map((period) => ({
    value: period.value,
    label: period.labelEn,
  })),
};

export const PERIOD_OPTIONS = {
  ar: [
    { value: 0, label: "بدون مقارنة" },
    { value: 1, label: "1 فترة سابقة" },
    { value: 2, label: "2 فترات سابقة" },
    { value: 3, label: "3 فترات سابقة" },
    { value: 4, label: "4 فترات سابقة" },
    { value: 5, label: "5 فترات سابقة" },
    { value: 6, label: "6 فترات سابقة" },
    { value: 7, label: "7 فترات سابقة" },
    { value: 8, label: "8 فترات سابقة" },
    { value: 9, label: "9 فترات سابقة" },
    { value: 10, label: "10 فترات سابقة" },
    { value: 11, label: "11 فترة سابقة" },
    { value: 12, label: "12 فترة سابقة" },
  ],
  en: [
    { value: 0, label: "No Comparison" },
    { value: 1, label: "1 Previous Period" },
    { value: 2, label: "2 Previous Periods" },
    { value: 3, label: "3 Previous Periods" },
    { value: 4, label: "4 Previous Periods" },
    { value: 5, label: "5 Previous Periods" },
    { value: 6, label: "6 Previous Periods" },
    { value: 7, label: "7 Previous Periods" },
    { value: 8, label: "8 Previous Periods" },
    { value: 9, label: "9 Previous Periods" },
    { value: 10, label: "10 Previous Periods" },
    { value: 11, label: "11 Previous Periods" },
    { value: 12, label: "12 Previous Periods" },
  ],
};

export const convertPeriodToDate = (period) => {
  if (!period) {
    return "";
  }

  if (period.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return period;
  }

  if (period.match(/^\d{4}-\d{2}$/)) {
    const [year, month] = period.split("-").map(Number);
    const lastDay = new Date(year, month, 0).getDate();
    return `${year}-${String(month).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
  }

  return period;
};

export const formatPeriodName = (periodValue, language = "ar") => {
  if (!periodValue) {
    return "";
  }

  let month;
  let year;

  if (periodValue.match(/^\d{4}-\d{2}$/)) {
    [year, month] = periodValue.split("-").map(Number);
  } else if (periodValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
    [year, month] = periodValue.split("-").map(Number);
  } else {
    return periodValue;
  }

  const monthIndex = month - 1;
  return language === "ar"
    ? `${arabicMonths[monthIndex]} ${year}`
    : `${englishMonths[monthIndex]} ${year}`;
};

export const getPeriodName = formatPeriodName;
